import { render, staticRenderFns } from "./ExportToExcel.vue?vue&type=template&id=12e5420c&scoped=true"
import script from "./ExportToExcel.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportToExcel.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e5420c",
  null
  
)

export default component.exports